import { ApiEnvironment } from '../../models/api-environment';

export class MiEnvironment extends ApiEnvironment {
  get instructionUrl() {
    return `${this.baseUrl}/api/instruction`;
  }

  get instructionVehicleGroupsUrl() {
    return `${this.baseUrl}/api/instruction/vehiclegroups`;
  }

  get instructionAssetUrl() {
    return `${this.baseUrl}/api/instruction/asset`;
  }

  get instructionAccountUrl() {
    return `${this.baseUrl}/api/instruction/account`;
  }

  get instructionPartnerUrl() {
    return `${this.baseUrl}/api/instruction/partner`;
  }

  get instructionFileUrl() {
    return `${this.baseUrl}/api/instruction/file`;
  }

  get instructionFileurlUrl() {
    return `${this.baseUrl}/api/instruction/fileurl`;
  }

  get instructionSearchUrl() {
    return `${this.baseUrl}/api/instruction/search`;
  }

  get instructionV2SearchUrl() {
    return `${this.baseUrl}/api/instruction/v2/search`;
  }

  get instructionStatusSearchUrl() {
    return `${this.baseUrl}/api/instruction/status/search`;
  }

  override resolve(environment: unknown) {
    return environment instanceof MiEnvironment ? environment : this;
  }
}

export const miEnvironment = new MiEnvironment();
